import React from 'react';

const Us1_st_ged = () => {
  return (
    <div>
      
    </div>
  );
}

export default Us1_st_ged;
